import type {AdPropertyConfigForFilters} from '@frontend/modules/public/ads/AdsModuleTypes'
import {
    type Dispatch,
    type SetStateAction,
    useEffect,
    useState,
} from 'react'
import type {AnyObject} from 'swayok-react-mdb-ui-kit/types/Common'
import {PublicAdsApi} from '../../PublicAdsApi'
import {AdCategoryFiltersDynamicInputs} from './AdCategoryFiltersDynamicInputs'

export interface AdCategoryPropertyFiltersFormValues {
    minPrice?: number | null
    maxPrice?: number | null
    props?: AnyObject
}

interface Props {
    categoryId?: number | null
    filters: AdCategoryPropertyFiltersFormValues
    setFilters: Dispatch<SetStateAction<AdCategoryPropertyFiltersFormValues>>
    isSubmitting: boolean
}

// Набор фильтров по свойствам объявлений.
export function AdCategoryPropertyFilters(props: Props) {

    const {
        categoryId,
        filters,
        setFilters,
        isSubmitting,
    } = props

    // Свойства.
    const [
        adPropertiesConfigs,
        setAdPropertiesConfigs,
    ] = useState<AdPropertyConfigForFilters[]>([])

    // Загрузка настроек динамических свойств объявлений.
    useEffect(() => {
        if (categoryId) {
            PublicAdsApi.getCategoryAdPropertiesForFilters(categoryId)
                .then(setAdPropertiesConfigs)
                .catch(() => {
                    // Игнорируем.
                })
        } else {
            setAdPropertiesConfigs([])
        }
    }, [categoryId])

    // Поля ввода.
    return (
        <AdCategoryFiltersDynamicInputs
            configs={adPropertiesConfigs}
            values={filters.props ?? {}}
            disabled={isSubmitting}
            onChange={setter => {
                setFilters(filters => ({
                    ...filters,
                    props: setter(filters.props ?? {}),
                }))
            }}
        />
    )
}
